import { postCheckKyc, postKyc } from "../api/kycApi";
import { CreateKycDto, KycFormInput, KycModel } from "../types/kyc";
// create-kyc no longer accepts personal_photo — keep upload helper commented
// import { postCheckKyc, postImage, postKyc } from "../api/kycApi";
// import { resizeImageFile } from "../utils/imageResize";
//
// export const uploadPersonalImage = async (image: File): Promise<string> => {
//   const reduced = await resizeImageFile(image, {
//     maxWidth: 1600,
//     maxHeight: 1600,
//     quality: 0.82,
//     mimeType: "image/jpeg",
//     targetBytes: 1_500_000,
//   });
//
//   const trimmedFileName = reduced.name.replace(/\s+/g, "_");
//   const renamedFile = new File([reduced], trimmedFileName, {
//     type: reduced.type,
//     lastModified: reduced.lastModified,
//   });
//
//   return postImage(renamedFile);
// };

export const submitKyc = async (
  formInput: KycFormInput,
  cusId: string,
  msisdn: string,
): Promise<KycModel> => {
  const docPhotoUrl = formInput.doc_photo_url?.trim() ?? "";
  if (formInput.doc_photo && !docPhotoUrl) {
    throw new Error("Passport photo upload is missing. Please upload it again.");
  }
  const jobId = formInput.job_id?.trim() ?? "";
  if (formInput.doc_photo && !jobId) {
    throw new Error("Passport OCR job id is missing. Please upload the passport photo again.");
  }

  // create-kyc no longer accepts personal_photo
  // const personalPhotoUrl = formInput.personal_photo
  //   ? await uploadPersonalImage(formInput.personal_photo)
  //   : "";

  const formatDate = (date?: string | Date | null) => {
    if (!date) return "";
    return new Date(date).toISOString().split("T")[0]; // YYYY-MM-DD
  };

  const kycPayload: CreateKycDto = {
    cus_id: cusId,
    name: formInput.name,
    surname: formInput.surname,
    birth_day: formatDate(formInput.birth_day),
    gender: formInput.gender,
    country: formInput.country,
    passport_no: formInput.passport_no,
    expiry_date: formatDate(formInput.expiry_date),
    nation: formInput.nation,
    doc_photo: docPhotoUrl,
    job_id: jobId,
    // personal_photo: personalPhotoUrl,
    msisdn,
  };

  const res = await postKyc(kycPayload);
  const kycProfile = res.profile;
  const kycModel = {
    kycQuota: res.usage,
    uuid: kycProfile.uuid,
    passportNumber: kycProfile.passport_number,
    passportCountry: kycProfile.passport_country,
    passportIssuedDate: kycProfile.passport_issued_date,
    passportExpiryDate: kycProfile.passport_expiry_date,
    dob: kycProfile.date_of_birth,
    firstname: kycProfile.first_name,
    lastname: kycProfile.last_name,
    gender: kycProfile.gender,
    nation: kycProfile.nationality,
  };

  return kycModel;
};

export interface CheckKycResult {
  profile: KycModel | null;
  isKycVerified: boolean;
}

export const checkKycStatus = async (
  cusId: string,
): Promise<CheckKycResult> => {
  const res = await postCheckKyc(cusId);
  const kycProfile = res.profile;
  if (kycProfile === null) {
    return {
      isKycVerified: false,
      profile: null,
    };
  }
  const kycModel: KycModel = {
    kycQuota: kycProfile.usage_limit,
    uuid: kycProfile.uuid,
    passportNumber: kycProfile.passport_number,
    passportCountry: kycProfile.passport_country,
    nation: kycProfile.nationality,
    passportIssuedDate: kycProfile.passport_issued_date,
    passportExpiryDate: kycProfile.passport_expiry_date,
    dob: kycProfile.date_of_birth,
    firstname: kycProfile.first_name,
    lastname: kycProfile.last_name,
    gender: kycProfile.gender,
  };
  return {
    isKycVerified: true,
    profile: kycModel,
  };
};
